import { render, staticRenderFns } from "./busca.vue?vue&type=template&id=0718dc65"
import script from "./busca.vue?vue&type=script&lang=js"
export * from "./busca.vue?vue&type=script&lang=js"
import style0 from "./busca.vue?vue&type=style&index=0&id=0718dc65&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports